<template>
  <header class="header header-sticky">
    <slot />
  </header>
</template>

<script>
export default {
  name: "MainHeader",
}
</script>
